var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBpIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#F25540"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25837_223984)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.8327 20.167C17.5552 20.167 17.2943 20.0286 17.1393 19.7961L15.7202 17.667H14.4993C14.0393 17.667 13.666 17.2937 13.666 16.8337C13.666 16.3737 14.0393 16.0003 14.4993 16.0003H16.166C16.4443 16.0003 16.7043 16.1395 16.8593 16.3712L17.7293 17.6762L19.5868 13.9603C19.7235 13.6887 19.996 13.512 20.3002 13.5003C20.621 13.492 20.8902 13.6437 21.0469 13.9037L23.3043 17.667H24.4994C24.9594 17.667 25.3327 18.0403 25.3327 18.5003C25.3327 18.9603 24.9594 19.3336 24.4994 19.3336H22.8327C22.5402 19.3336 22.2685 19.1803 22.1185 18.9295L20.3993 16.0645L18.5785 19.707C18.4452 19.9728 18.181 20.1478 17.8843 20.1661C17.8677 20.167 17.8502 20.167 17.8327 20.167Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8327 20.9995C21.9577 20.9995 21.141 20.5328 20.691 19.7828L20.5327 19.5245L20.066 20.4495C19.6743 21.2495 18.8743 21.7745 17.991 21.8245L17.8327 21.8328C16.991 21.8328 16.216 21.4162 15.7493 20.7162L14.8243 19.3328H14.4993C13.1243 19.3328 11.9993 18.2078 11.9993 16.8328C11.9993 15.4578 13.1243 14.3328 14.4993 14.3328H16.166C16.5993 14.3328 17.016 14.4411 17.3827 14.6495L18.0993 13.2161C18.5077 12.3995 19.3243 11.8661 20.241 11.8328C20.5993 11.8245 20.9494 11.8828 21.266 12.0161C19.291 8.90781 16.7827 6.35781 16.6077 6.18281C16.3743 5.94948 15.9577 5.94948 15.7243 6.18281C15.4327 6.47448 8.66602 13.3578 8.66602 18.4412C8.66602 22.6078 12.0327 25.9995 16.166 25.9995C19.4077 25.9995 22.1827 23.9078 23.2243 20.9995H22.8327Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25837_223984"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(7 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBpIcon);
export default __webpack_public_path__ + "static/media/bp-icon.4da184ded6bc015c399a321508640a4b.svg";
export { ForwardRef as ReactComponent };